// src/crm/ugc/HighRateConfirm.tsx
//
// Confirmation d'un montant pour 1 000 vues élevé (plus de 10 €, highRateQuestion) : la question
// avec le montant au plus par vidéo, « Confirmer ce montant » ou « Corriger ». Une faute de frappe
// (25 au lieu de 2,5) ne part pas d'un seul clic.

export function HighRateConfirm({
  question,
  busy,
  onConfirm,
  onCancel,
}: {
  question: string
  busy: boolean
  onConfirm: () => void
  onCancel: () => void
}) {
  return (
    <div className="ugc-inline-form" role="alertdialog" aria-label="Montant élevé">
      <p className="ugc-confirm">{question}</p>
      <div className="ugc-actions">
        <button type="button" className="ugc-btn ugc-btn--strong" disabled={busy} onClick={onConfirm}>
          Confirmer ce montant
        </button>
        <button type="button" className="ugc-btn" disabled={busy} onClick={onCancel}>
          Corriger
        </button>
      </div>
    </div>
  )
}
